import React, {
  useEffect,
} from "react";
import TextInputField from "controls/global/text-input-field";
import useFormWrapper from "utils/custom-hooks/useFormWrapper";
import { useProfileSettingsCache } from "utils/context/ProfileSettingsContext";

interface Props {
  schema: string;
  name: string;
  productIndex: number;
  disabled?: boolean;
  onChange?: () => void;
}

const NotificationEmailAddresses = ({ schema, name, productIndex, disabled, onChange }: Props) => {
  const { setValue, getValues, clearErrors, trigger  } = useFormWrapper();
  const [{ profileSettings }] = useProfileSettingsCache();
  const userEmailAddress = profileSettings?.userName;

  const notificationEmailAddresses = getValues(name);

  const validateNotificationEmailAddress = () => {
    if (notificationEmailAddresses && !disabled) {
      clearErrors(name);
      //setValue(`${schema}.isValidationRequired`, true);
      setValue(`${schema}.isEmailFormatValidationRequired`, true);
      trigger(name);
    }
  }

  const handleOnChange = (event: React.ChangeEvent<any>) => {
    setValue(`${schema}.isDefault`, false);
    setValue(`${schema}.isNotificationEmailAddressesDirty`, true);

    onChange && onChange();
  }

  const handleOnBlur = () => {
    validateNotificationEmailAddress();
  }


  useEffect(() => {
    // console.log(tsAgencyConfig);
    const productID: number = getValues(`${schema}.productID`) || 0;
    const isNotificationEmailAddressesDirty: boolean = getValues(
      `${schema}.isNotificationEmailAddressesDirty`
    ) || false;
    if (!isNotificationEmailAddressesDirty && productID === 0) {
      // Use profile Email as a default
      const defaultEmail = userEmailAddress;
      setValue(name, defaultEmail, { shouldDirty: false, shouldValidate: false, shouldTouch: false });
    }
  }, [userEmailAddress, notificationEmailAddresses])


  return (
    <>
      <TextInputField
        name={name}
        placeholder="Email"
        label="Email For Notifications"
        style={{ position: "relative" }}
        disabled={disabled}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
      />
    </>
  );

}


export default NotificationEmailAddresses;